export default {
  EVENTS ({ events }) {
    return events
  },
  BESTELLUNGEN ({ bestellungen }) {
    return bestellungen
  }
}
